export default __webpack_public_path__ + "static/media/img-0728-latvia-full-face.855d62a1.png";